import { render } from "./ThreeAxleTractorFourAxleSemitrailer.vue?vue&type=template&id=5feac8bb&scoped=true&ts=true"
import script from "./ThreeAxleTractorFourAxleSemitrailer.vue?vue&type=script&lang=ts"
export * from "./ThreeAxleTractorFourAxleSemitrailer.vue?vue&type=script&lang=ts"

import "./ThreeAxleTractorFourAxleSemitrailer.vue?vue&type=style&index=0&id=5feac8bb&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\330398ee0e098db7\\LoadingSokoldok\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5feac8bb"]])

export default __exports__